import "./AssignResponsibleOwnerModal.css";

import { FormEvent } from "react";

import { ActionButtons } from "../../forms";
import { Column, Row } from "../../layout";
import { Modal } from "../Modal";
import { AssignResponsibleOwnerModalProps } from "./models";

export const AssignResponsibleOwnerModal = ({
  show,
  newOwnerName,
  currentOwnerName,
  onConfirm,
  onCancel,
  isLoading = false,
}: AssignResponsibleOwnerModalProps): JSX.Element => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onConfirm();
  };

  // The name ends the sentence, and one ending in "Ltd." already carries its full stop.
  const currentOwner = currentOwnerName ?? "the organisation that currently holds it";
  const closingStop = currentOwner.endsWith(".") ? "" : ".";

  return (
    <Modal
      className="AssignResponsibleOwnerModal"
      show={show}
      title="Assign responsible owner"
      onClose={onCancel}
      onBackdrop={onCancel}
    >
      <form onSubmit={handleSubmit}>
        <div className="AssignResponsibleOwnerModal_content">
          <p className="body2">
            Are you sure you want to make {newOwnerName ?? "this organisation"} the Responsible Owner? Only one
            organisation can hold this role at a time, so this will remove Responsible Owner status from {currentOwner}
            {closingStop}
          </p>
          <Row justify="center">
            <Column span={6} hasNoPadding>
              <ActionButtons
                fullWidth
                submitButtonLabel="Confirm"
                onCancel={onCancel}
                isLoading={isLoading}
                disabled={isLoading}
              />
            </Column>
          </Row>
        </div>
      </form>
    </Modal>
  );
};
